// Home.jsx
import React from "react";
import { useNavigate } from 'react-router-dom';
import {
  IonContent,
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonCardSubtitle,
  IonButton,
  IonText,
  IonIcon,
  IonGrid,
  IonRow,
  IonCol,
  IonButtons
} from '@ionic/react';
import { rocketOutline, globeOutline, mailOutline, arrowBackOutline } from 'ionicons/icons';

const Launch = ({ user }) => {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    window.open('https://www.tryhood.com', '_blank');
  };

  const goBack = () => {
    navigate(-1);
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={goBack}>
              <IonIcon icon={arrowBackOutline} />
            </IonButton>
          </IonButtons>
          <IonTitle>Welcome</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonGrid>
          <IonRow>
            <IonCol size="12" sizeMd="8" offsetMd="2">
              <div style={{
                textAlign: 'center',
                padding: '3rem 1rem',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                borderRadius: '20px',
                margin: '2rem 0',
                color: 'white'
              }}>
                <IonIcon
                  icon={rocketOutline}
                  style={{ fontSize: '4rem', marginBottom: '1rem' }}
                />
                <IonText>
                  <h1 style={{ fontSize: '2rem', fontWeight: 'bold' }}>
                    Welcome {user.given_name}!
                  </h1>
                </IonText>
              </div>
            </IonCol>
          </IonRow>

          <IonRow>
            <IonCol size="12">
              <IonCard>
                <IonCardHeader>
                  <IonCardTitle>🎉 HOOD is Coming Soon!</IonCardTitle>
                  <IonCardSubtitle>Get ready for the future of ridesharing</IonCardSubtitle>
                </IonCardHeader>
                <IonCardContent>
                  <IonText>
                    <p style={{ fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1.5rem' }}>
                      Keep a close eye on your inbox for a possible invitation to our Beta program!
                      You'll be among the first to experience the revolutionary way to travel.
                    </p>
                  </IonText>

                  <IonButton
                    expand="block"
                    onClick={handleLearnMore}
                    color="primary"
                    style={{ marginTop: '1rem' }}
                  >
                    <IonIcon icon={globeOutline} slot="start" />
                    Learn More About HOOD
                  </IonButton>
                </IonCardContent>
              </IonCard>
            </IonCol>
          </IonRow>

          <IonRow>
            <IonCol size="12">
              <IonCard>
                <IonCardContent>
                  <div style={{ textAlign: 'center', padding: '1rem' }}>
                    <IonIcon
                      icon={mailOutline}
                      color="primary"
                      style={{ fontSize: '2rem', marginBottom: '1rem' }}
                    />
                    <IonText color="medium">
                      <p>We'll notify you as soon as HOOD is ready for you!</p>
                    </IonText>
                  </div>
                </IonCardContent>
              </IonCard>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default Launch;